import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Header from "../../layouts/Header";
import { Tooltip } from "antd";
import downArrow from "../../assets/icons/down arrow.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProjectCostDetailsByProjectId,
  FetchProjectEquipmentActivity,
  GlobalRequest,
} from "../../redux/actions/action";
import {
  europeanFormat,
  europeanFormatWithSymbol,
} from "../../utils/European-Format/NumberFormatter";
import moment from "moment";
import axios from "axios";
import { API_URL } from "../../redux/constants/type";

import { DownloadAndOpenQuotesPDF } from "../../redux/actions/proformaAction";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import "../../assets/styles/local/FinancialCostDetails.css";

const convertHoursToHM = (decimalHours) => {
  const hours = Math.floor(decimalHours);
  const minutes = Math.round((decimalHours - hours) * 60);
  return `${hours}:${minutes.toString().padStart(2, "0")}`;
};

const FinancialCostDetails = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [costDetails, setCostDetails] = useState({});
  const [equipmentData, setEquipmentData] = useState([]);
  const [showWorkerSpace, setShowWorkerSpace] = useState(false);
  const [showEquipmentSpace, setShowEquipmentSpace] = useState(false);
  const [showMaterialSpace, setShowMaterialSpace] = useState(false);

  const projectCostDetails = useSelector((s) => s.user.projectCostDetails);
  const fetchProjectEquipmentActivityRes = useSelector(
    (s) => s.user.fetchProjectEquipmentActivityRes,
  );

  const [workerMargin, setWorkerMargin] = useState(0);
  const [materialMargin, setMaterialMargin] = useState(0);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Project").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const calculateWorkerMargin = () => {
    setCostDetails((data) => {
      let refData = JSON.parse(JSON.stringify(data));
      let worker = refData.workers;

      refData.workerTotalMargin = 0;
      refData.workerTotal = 0;
      refData.total = 0;

      worker.forEach((ele) => {
        ele.margin = Number(workerMargin);
        ele.marginAmount =
          (Number(workerMargin) / 100) * Number(ele.totalHourCost);
        ele.total =
          Number(ele.totalHourCost) +
          (Number(workerMargin) / 100) * Number(ele.totalHourCost);

        refData.workerTotalMargin +=
          (Number(workerMargin) / 100) * Number(ele.totalHourCost);
        refData.workerTotal +=
          Number(ele.totalHourCost) +
          (Number(workerMargin) / 100) * Number(ele.totalHourCost);
      });

      refData.total =
        Number(refData.workerTotal) + Number(refData.materialTotal);
      // refData.btw9 = (0.09 * refData.total) + refData.total;
      // refData.btw21 = (0.21 * refData.total) + refData.total;
      refData.totalIncludingBtw = refData.total;

      refData.workers = worker;
      return refData;
    });
  };

  const calculateMaterialMargin = () => {
    setCostDetails((data) => {
      let refData = JSON.parse(JSON.stringify(data));
      let material = refData.materials;

      refData.materialTotalMargin = 0;
      refData.materialTotal = 0;
      refData.total = 0;

      material.forEach((ele) => {
        ele.margin = Number(materialMargin);
        ele.marginAmount =
          (Number(materialMargin) / 100) * Number(ele.totalCost);
        ele.total =
          Number(ele.totalCost) +
          (Number(materialMargin) / 100) * Number(ele.totalCost);

        refData.materialTotalMargin +=
          (Number(materialMargin) / 100) * Number(ele.totalCost);
        refData.materialTotal +=
          Number(ele.totalCost) +
          (Number(materialMargin) / 100) * Number(ele.totalCost);
      });

      refData.total =
        Number(refData.workerTotal) + Number(refData.materialTotal);
      // refData.btw9 = (0.09 * refData.total) + refData.total;
      // refData.btw21 = (0.21 * refData.total) + refData.total;
      refData.totalIncludingBtw = refData.total;

      refData.material = material;
      return refData;
    });
  };

  useEffect(() => {
    const projectId = window.localStorage.getItem("projectid");
    dispatch(fetchProjectCostDetailsByProjectId(projectId));
  }, []);

  useEffect(() => {
    const projectId = window.localStorage.getItem("projectid");
    dispatch(FetchProjectEquipmentActivity({ projectId: projectId }));
  }, []);

  useEffect(() => {
    if (projectCostDetails.status) {
      setCostDetails(projectCostDetails.data);

      if (
        projectCostDetails.data &&
        projectCostDetails.data.materials &&
        projectCostDetails.data.materials.length
      )
        setMaterialMargin(Number(projectCostDetails.data.materials[0].margin));

      if (
        projectCostDetails.data &&
        projectCostDetails.data.materials &&
        projectCostDetails.data.workers.length
      )
        setWorkerMargin(Number(projectCostDetails.data.workers[0].margin));
    }
  }, [projectCostDetails]);

  useEffect(() => {
    if (fetchProjectEquipmentActivityRes.status) {
      setEquipmentData(fetchProjectEquipmentActivityRes?.data);
    }
  }, [fetchProjectEquipmentActivityRes]);

  const saveMargins = async () => {
    const projectId = window.localStorage.getItem("projectid");

    dispatch(
      GlobalRequest({
        url: `${API_URL}/api/User/AddProjectMargine`,
        method: "put",
        data: {
          projectId: projectId,
          workerMargine: workerMargin,
          materialMargine: materialMargin,
        },
        state: "updateMargins",
      }),
    );

    history.goBack();
  };

  // equipments space start
  const [equipmentMargin, setEquipmentMargin] = useState(0);

  const calculateEquipmentMargin = () => {
    setEquipmentData((prev) =>
      prev.map((eq) => {
        const marginAmount =
          (Number(equipmentMargin) / 100) * Number(eq.totalCost);

        return {
          ...eq,
          margin: Number(equipmentMargin),
          marginAmount,
          totals: Number(eq.totalCost) + marginAmount,
        };
      }),
    );
  };

  const equipmentTotalHours = equipmentData?.reduce(
    (sum, eq) => sum + Number(eq.totalTrackedTime || 0),
    0,
  );

  const equipmentTotalCost = equipmentData?.reduce(
    (sum, eq) => sum + Number(eq.totalCost || 0),
    0,
  );

  const equipmentTotalMargin = equipmentData?.reduce(
    (sum, eq) => sum + Number(eq.marginAmount || 0),
    0,
  );

  const equipmentTotals = equipmentData?.reduce(
    (sum, eq) => sum + Number(eq.totals || 0),
    0,
  );

  return (
    <>
      <Header
        leftComponent={
          <div className="flex-wrap gap-4 d-flex align-items-baseline">
            <div
              className="projectText"
              onClick={() => {
                history.push("/project");
              }}
            >
              {/* Projects */}
              {t("Projects")}
            </div>
            <div className="pt-2 d-flex pe-3" style={{ background: "#FFFFFF" }}>
              <p className="pt-1 ps-4 projectText2">
                {/* Project */}
                {t("Project")}
              </p>
              {/* <p className="pt-1 projectID ps-5"> ID &nbsp;{projectcode} </p> */}
            </div>
          </div>
        }
      />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          paddingRight: "36.5px",
        }}
      >
        <button
          type="button"
          className="addProAdd"
          onClick={() => saveMargins()}
        >
          {/* Close */}
          {t("Close")}
        </button>
      </div>
      <div className="fcost-main-div">
        <div className="fcost-div-1">
          <p className="fcost-costs-text">
            {/* costs */}
            {t("Costs")}
          </p>
          <section className="fcost-costs-total">
            <p>
              {/* Total */}
              {t("Total")}
            </p>
            <p>{europeanFormatWithSymbol(costDetails?.total)}</p>
          </section>
          <section className="fcost-costs-total fcost-costs-btw9">
            <p>
              {/* Btw 9% */}
              {t("Btw 9%")}
            </p>
            <p>{europeanFormatWithSymbol(costDetails?.btw9)}</p>
          </section>
          <section className="fcost-costs-total fcost-costs-btw9">
            <p>
              {/* Btw 21% */}
              {t("Btw 21%")}
            </p>
            <p>{europeanFormatWithSymbol(costDetails?.btw21)}</p>
          </section>
          <section className="fcost-costs-total fcost-costs-btw9">
            <p>
              {/* Total incl. Btw */}
              {t("Total Incl.Btw")}
            </p>
            <p style={{ fontWeight: "bold" }}>
              {europeanFormatWithSymbol(costDetails?.totalIncludingBtw)}
            </p>
          </section>
        </div>

        {/* workers tab */}
        <div style={{ backgroundColor: "white" }}>
          <div
            className="fcost-div-1 fcost-div-worker"
            onClick={() => setShowWorkerSpace(!showWorkerSpace)}
          >
            <p className="fcost-workers-text">
              {/* Workers */}
              {t("Workers")}
            </p>
            <div className="fcost-workers-hours-grid">
              <section className="fcost-workers-hours">
                <p>
                  {/* Hours */}
                  {t("Hours")}
                </p>
                {/* <p>{europeanFormat(costDetails?.workerTotalHours)}</p> */}
                <p>{convertHoursToHM(costDetails?.workerTotalHours)}</p>
              </section>
            </div>
            <section className="fcost-workers-hours">
              <p>
                {/* Total Cost */}
                {t("Total Cost")}
              </p>
              <p>{europeanFormatWithSymbol(costDetails?.workerTotalCosts)}</p>
            </section>
            <section className="fcost-workers-hours">
              <p>
                {/* Margin */}
                {t("Margin")}
              </p>
              <p>{europeanFormatWithSymbol(costDetails?.workerTotalMargin)}</p>
            </section>
            <div className="fcost-workers-hours-grid">
              <section className="fcost-workers-hours">
                <p>
                  {/* Totals */}
                  {t("Totals")}
                </p>
                <p>{europeanFormatWithSymbol(costDetails?.workerTotal)}</p>
              </section>
              <section style={{ paddingBottom: "5px", placeSelf: "end" }}>
                <img
                  alt=""
                  src={downArrow}
                  style={{
                    cursor: "pointer",
                    placeSelf: "end",
                    transform: showWorkerSpace
                      ? "rotate(-180deg)"
                      : "rotate(0)",
                    transitionDuration: "300ms",
                  }}
                />
              </section>
            </div>
          </div>
          {showWorkerSpace && (
            <WorkerSpace
              workers={costDetails.workers}
              calculateWorkerMargin={calculateWorkerMargin}
              workerMargin={workerMargin}
              setWorkerMargin={setWorkerMargin}
              FetchTranslationList={FetchTranslationList}
            />
          )}
        </div>

        {/* expenses tav */}
        <div style={{ backgroundColor: "white" }}>
          <div
            className="fcost-div-1 fcost-div-worker"
            onClick={() => setShowMaterialSpace(!showMaterialSpace)}
          >
            <p className="fcost-workers-text">
              {/* Expenses */}
              {t("Expenses")}
            </p>
            <div className="fcost-workers-hours-grid">
              <section className="fcost-workers-hours">
                <p></p>
                <p></p>
              </section>
            </div>
            <section className="fcost-workers-hours">
              <p>
                {/* Total Cost */}
                {t("Total Cost")}
              </p>
              <p>{europeanFormatWithSymbol(costDetails?.materialTotalCosts)}</p>
            </section>
            <section className="fcost-workers-hours">
              <p>
                {/* Margin */}
                {t("Margin")}
              </p>
              <p>
                {europeanFormatWithSymbol(costDetails?.materialTotalMargin)}
              </p>
            </section>
            <div className="fcost-workers-hours-grid">
              <section className="fcost-workers-hours">
                <p>
                  {/* Totals */}
                  {t("Totals")}
                </p>
                <p>{europeanFormatWithSymbol(costDetails?.materialTotal)}</p>
              </section>
              <section style={{ paddingBottom: "5px", placeSelf: "end" }}>
                <img
                  alt=""
                  src={downArrow}
                  style={{
                    cursor: "pointer",
                    placeSelf: "end",
                    transform: showMaterialSpace
                      ? "rotate(-180deg)"
                      : "rotate(0)",
                    transitionDuration: "300ms",
                  }}
                />
              </section>
            </div>
          </div>
          {showMaterialSpace && (
            <MaterialSpace
              metrials={costDetails.materials}
              calculateMaterialMargin={calculateMaterialMargin}
              materialMargin={materialMargin}
              setMaterialMargin={setMaterialMargin}
              FetchTranslationList={FetchTranslationList}
            />
          )}
        </div>

        {/* equipments tab */}
        <div style={{ backgroundColor: "white" }}>
          <div
            className="fcost-div-1 fcost-div-worker"
            onClick={() => setShowEquipmentSpace(!showEquipmentSpace)}
          >
            <p className="fcost-workers-text">
              {/* Equipment */}
              {t("Equipment")}
            </p>
            <div className="fcost-workers-hours-grid invisible">
              <section className="fcost-workers-hours">
                <p>
                  {/* Hours */}
                  {t("Hours")}
                </p>
                {/* <p>{europeanFormat(costDetails?.workerTotalHours)}</p> */}
                <p>{convertHoursToHM(equipmentTotalHours)}</p>
              </section>
            </div>
            <section className="fcost-workers-hours">
              <p>
                {/* Total Cost */}
                {t("Total Cost")}
              </p>
              <p>{europeanFormatWithSymbol(equipmentTotalCost)}</p>
            </section>
            <section className="fcost-workers-hours">
              <p>
                {/* Margin */}
                {t("Margin")}
              </p>
              <p>{europeanFormatWithSymbol(equipmentTotalMargin)}</p>
            </section>
            <div className="fcost-workers-hours-grid">
              <section className="fcost-workers-hours">
                <p>
                  {/* Totals */}
                  {t("Totals")}
                </p>
                <p>{europeanFormatWithSymbol(equipmentTotals)}</p>
              </section>
              <section style={{ paddingBottom: "5px", placeSelf: "end" }}>
                <img
                  alt=""
                  src={downArrow}
                  style={{
                    cursor: "pointer",
                    placeSelf: "end",
                    transform: showEquipmentSpace
                      ? "rotate(-180deg)"
                      : "rotate(0)",
                    transitionDuration: "300ms",
                  }}
                />
              </section>
            </div>
          </div>
          {showEquipmentSpace && (
            <EquipmentSpace
              equipments={equipmentData}
              calculateEquipmentMargin={calculateEquipmentMargin}
              equipmentMargin={equipmentMargin}
              setEquipmentMargin={setEquipmentMargin}
              FetchTranslationList={FetchTranslationList}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default FinancialCostDetails;

const WorkerSpace = ({
  workers,
  calculateWorkerMargin,
  workerMargin,
  setWorkerMargin,
  FetchTranslationList,
}) => {
  const t = (key) => FetchTranslationList?.[key] || "";
  return (
    <div className="worker-space-cont">
      <section className="space-head-div">
        <p style={{ textAlign: "start" }}>
          {/* Name */}
          {t("Name")}
        </p>
        <div className="space-head-grid">
          <p>
            {/* Hours */}
            {t("Hours")}
          </p>
          <p>
            {/* Cost Hour */}
            {t("Cost Hour")}
          </p>
        </div>
        <p>
          {/* Total Cost */}
          {t("Total Cost")}
        </p>
        <div className="space-head-grid">
          <div className="space-head-div-text-style">
            <div>
              {/* Margin */}
              {t("Margin")}
            </div>
            <div>
              <span
                style={{ fontWeight: "bold", color: "#333333", opacity: "1" }}
              >
                <input
                  type="text"
                  value={workerMargin}
                  onChange={(e) => setWorkerMargin(e.target.value)}
                  onBlur={() => calculateWorkerMargin()}
                  style={{ border: "none", width: "33px", textAlign: "center" }}
                />
                %
              </span>
            </div>
          </div>
          <p>
            {/* Margin <br />
            Amount */}
            {t("Margin Amount").slice(0, 6)}
            <br />
            {t("Margin Amount").slice(6)}
          </p>
        </div>
        <div className="fcost-workers-hours-grid">
          <p>
            {/* Totals */}
            {t("Totals")}
          </p>
          <section></section>
        </div>
        <section className="space-head-line"></section>
      </section>
      {workers.map((item, index) => {
        return (
          <section
            className="space-content-div"
            key={`project-cost-worker-${index}`}
          >
            <p style={{ textAlign: "start" }}>{item.workerName}</p>
            <div className="space-head-grid">
              {/* <p>{europeanFormat(item?.hours)}</p> */}
              <p>{convertHoursToHM(item?.hours)}</p>
              <p>{europeanFormatWithSymbol(item?.costPerHour)}</p>
            </div>
            <p>{europeanFormatWithSymbol(item?.totalHourCost)}</p>
            <div className="space-head-grid">
              <p>{europeanFormat(item?.margin)}%</p>
              <p>{europeanFormatWithSymbol(item?.marginAmount)}</p>
            </div>
            <div className="fcost-workers-hours-grid">
              <p>{europeanFormatWithSymbol(item?.total)}</p>
              <section></section>
            </div>
          </section>
        );
      })}
    </div>
  );
};

const MaterialSpace = ({
  metrials,
  calculateMaterialMargin,
  materialMargin,
  setMaterialMargin,
  FetchTranslationList,
}) => {
  const t = (key) => FetchTranslationList?.[key] || "";
  return (
    <div className="worker-space-cont">
      <section className="space-head-div">
        <div style={{ display: "grid", gridTemplateColumns: "0.4fr 0.6fr" }}>
          <p style={{ textAlign: "start" }}>
            {/* Date */}
            {t("Date")}
          </p>
          <p style={{ textAlign: "start" }}>
            {/* Supplier Name */}
            {t("Supplier Name")}
          </p>
        </div>
        <div className="space-head-grid">
          <p></p>
          <p>
            {/* Doc Nr. */}
            {t("Doc Nr.")}
          </p>
        </div>
        <p>
          {/* Total Cost */}
          {t("Total Cost")}
        </p>
        <div className="space-head-grid">
          <div className="space-head-div-text-style">
            <div>
              {/* Margin */}
              {t("Margin")}
            </div>
            <div>
              <span
                style={{ fontWeight: "bold", color: "#333333", opacity: "1" }}
              >
                <input
                  type="text"
                  value={materialMargin}
                  onChange={(e) => setMaterialMargin(e.target.value)}
                  onBlur={() => calculateMaterialMargin()}
                  style={{ border: "none", width: "33px", textAlign: "center" }}
                />
                %
              </span>
            </div>
          </div>
          <p>
            {/* Margin <br />
            Amount */}

            {t("Margin Amount").slice(0, 6)}
            <br />
            {t("Margin Amount").slice(6)}
          </p>
        </div>
        <div className="fcost-workers-hours-grid">
          <p>
            {/* Totals */}
            {t("Totals")}
          </p>
          <section></section>
        </div>
        <section className="space-head-line"></section>
      </section>
      {metrials.map((item, index) => {
        return (
          <section
            className="space-content-div"
            key={`project-cost-metrial-${index}`}
          >
            <div
              style={{ display: "grid", gridTemplateColumns: "0.4fr 0.6fr" }}
            >
              <p style={{ textAlign: "start" }}>
                {moment(item.date).format("MM.DD.YYYY")}
              </p>
              <p style={{ textAlign: "start" }}>{item.supplierName}</p>
            </div>
            <div className="space-head-grid">
              <p></p>
              <a
                className="doc-link"
                onClick={() => {
                  DownloadAndOpenQuotesPDF(item.orderId).then(
                    (result) => {
                      console.log(result);
                    },
                    (error) => {
                      console.error(error);
                    },
                  );
                  console.log(item.orderId);
                }}
              >
                {item.docNumber}
              </a>
            </div>
            <p>{europeanFormatWithSymbol(item?.totalCost)}</p>
            <div className="space-head-grid">
              <p>{europeanFormat(item?.margin)}%</p>
              <p>{europeanFormatWithSymbol(item?.marginAmount)}</p>
            </div>
            <div className="fcost-workers-hours-grid">
              <p>{europeanFormatWithSymbol(item?.total)}</p>
              <section></section>
            </div>
          </section>
        );
      })}
    </div>
  );
};

const EquipmentSpace = ({
  equipments,
  calculateEquipmentMargin,
  equipmentMargin,
  setEquipmentMargin,
  FetchTranslationList,
}) => {
  const t = (key) => FetchTranslationList?.[key] || "";
  return (
    <div className="worker-space-cont">
      <section className="equip-space-head-div">
        <p style={{ textAlign: "start" }}>
          {/* Equipment */}
          {t("Equipment")}
        </p>
        <p>
          {/* Task */}
          {t("Task")}
        </p>
        <p>
          {/* Time Spent */}
          {t("Time Spent")}
        </p>
        <p>
          {/* Cost Rate */}
          {t(" Cost Rate")}
        </p>
        <p>
          {/* Total Cost */}
          {t("Total Cost")}
        </p>
        <div className="">
          <div>
            {/* Margin */}
            {t("Margin")}
          </div>
          <div>
            <span
              style={{ fontWeight: "bold", color: "#333333", opacity: "1" }}
            >
              <input
                type="text"
                value={equipmentMargin}
                onChange={(e) => setEquipmentMargin(e.target.value)}
                onBlur={() => calculateEquipmentMargin()}
                style={{ border: "none", width: "33px", textAlign: "center" }}
              />
              %
            </span>
          </div>
        </div>
        <p>
          {/* Margin <br />
            Amount */}
          {t("Margin Amount").slice(0, 6)}
          <br />
          {t("Margin Amount").slice(6)}
        </p>

        <div className="fcost-workers-hours-grid">
          <p>
            {/* Totals */}
            {t("Totals")}
          </p>
          <section></section>
        </div>
        <section className="space-head-line"></section>
      </section>
      {equipments.map((item, eqIndex) => {
        return (
          <section className="equip-space-content-div" key={item.activityId}>
            <Tooltip title={item?.equipmentname}>
              <p style={{ textAlign: "start" }}>{item.equipmentname}</p>
            </Tooltip>
            <p style={{ textAlign: "start" }}>{item.activityName}</p>
            <p style={{ textAlign: "start" }}>{item.timeSpentMinutes} min</p>
            <p style={{ textAlign: "start" }}>
              {/* {europeanFormatWithSymbol(item.costRate)} */}
              {europeanFormatWithSymbol(
                Number(String(item.costRate).replace(",", ".")),
              )}
            </p>
            <p style={{ textAlign: "start" }}>
              {europeanFormatWithSymbol(item?.totalCost)}
            </p>
            <p>{europeanFormat(item?.margin)}%</p>

            <div className="d-none">
              <p>{convertHoursToHM(item?.totalTrackedTime)}</p>
            </div>

            <div className="">
              <p>{europeanFormatWithSymbol(item?.marginAmount)}</p>
            </div>
            <div className="">
              <p>{europeanFormatWithSymbol(item?.totals)}</p>
              <section></section>
            </div>
          </section>
        );
      })}
    </div>
  );
};
